import { CURRENCY, INDICATOR } from '@voladeum/client';
import { INDICATOR_COLOR, PARAMETER } from 'enums';
import { Width } from 'framework/theme/types';

export const EMPTY_FUNCTION = () => {};
export const EMPTY_PROMISE = () => Promise.resolve();
export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
export const OPTION_HEIGHT = 30;
export const OPTION_PADDING = 5;
export const OPTIONS_BORDER = 2;
export const OPTIONS_OFFSET = 1;
export const SELECT_MIN_WIDTH = 150;
export const SELECT_SLIM_HEIGHT = '30px';
export const GRID_LINE_HEIGHT = 1.2;
export const GRID_MIN_CELL_WIDTH = 50;
export const INPUT_DEBOUNCE = 300;
export const GRID_ROW_BORDER = 2;
export const OPTIONS_EDGE_THRESHOLD = 20;
export const TRIGGER_PADDING = 14;
export const CANDLE_VALIDATION_ERROR_THRESHOLD = 0.95;
export const CANDLE_WINDOW = 180;
export const DRAWER_CLOSED = 50;
export const DRAWER_OPEN = 200;
export const BUY_ID = 'voladeum-buy';
export const SELL_ID = 'voladeum-sell';
export const MODAL_ID = 'voladeum-modal';
export const POPOVER_ID = 'voladeum-popover';
export const TOOLBAR_ID = 'voladeum-toolbar';
export const TOOLTIP_ID = 'voladeum-tooltip';
export const TOOLTIP_TITLE_ID = 'voladeum-title-tooltip';
export const TOOLTIP_CANDLE_VALIDATION_ID = 'voladeum-tooltip-validation';

export const CRYPTO_PATH = {
  [CURRENCY.BITCOIN]: 'bitcoin',
  [CURRENCY.ETHEREUM]: 'ethereum',
  [CURRENCY.LITECOIN]: 'litecoin',
  [CURRENCY.DOLLAR]: 'dollar',
};

export const INDICATOR_NAME: Partial<Record<INDICATOR, string>> = {
  [INDICATOR.MACD]: 'MACD',
  [INDICATOR.CCI]: 'CCI',
  [INDICATOR.ATR]: 'ATR',
  [INDICATOR.OBV]: 'OBV',
  [INDICATOR.STANDARD_DEV]: 'Standard Deviation',
  [INDICATOR.ACCUMULATION_DIST]: 'Accumulation/Distribution',
};

export const INDICATOR_COLOR_HEX: Record<INDICATOR_COLOR, string> = {
  [INDICATOR_COLOR.PURPLE]: 'rgba(146, 121, 244, 0.9)',
  [INDICATOR_COLOR.INDIGO]: 'rgba(63, 81, 181, 0.9)',
  [INDICATOR_COLOR.GREEN]: 'rgba(38, 166, 154, 0.9)',
  [INDICATOR_COLOR.RED]: 'rgba(239, 83, 80, 0.9)',
  [INDICATOR_COLOR.ORANGE]: 'rgba(245, 172, 46, 0.9)',
  [INDICATOR_COLOR.WHITE]: 'rgba(128, 131, 151, 0.9)',
  [INDICATOR_COLOR.BLUE]: 'rgba(46, 140, 245, 0.9)',
  [INDICATOR_COLOR.YELLOW]: 'rgba(255, 235, 59, 0.9)',
  [INDICATOR_COLOR.GREY]: 'rgba(128, 128, 128, 0.9)',
  [INDICATOR_COLOR.CYAN]: 'rgba(0, 188, 212, 0.9)',
  [INDICATOR_COLOR.PINK]: 'rgba(233, 30, 99, 0.9)',
};

export const PARAMETER_NAME: Record<PARAMETER, string> = {
  [PARAMETER.THRESHOLD]: '',
};

export const VARIANT = { DARK: 'dark', LIGHT: 'light' };

export const MAX_POSITION_PCT = '20%';
export const MAX_DAILY_LOSS_PCT = '20%';
export const MAX_DRAWDOWN_PCT = '20%';
export const EXPIRY_VALUE = '7';
export const STOP_LOSS_OFFSET_PCT = '1%';
export const TAKE_PROFIT_OFFSET_PCT = '2%';
export const TAKE_PROFIT_TRAIL_PCT = '1%';
export const SLIPPAGE_TOLERANCE_PCT = '0.5%';
export const ACTIVATION_THRESHOLD = '1';

export const BORDER = {
  PURPLE: 'rgba(146, 121, 244, 1)',
  GREEN: 'rgba(38, 166, 154, 1)',
  RED: 'rgba(239, 83, 80, 1)',
  ORANGE: 'rgba(245, 172, 46, 1)',
  WHITE: 'rgba(128, 131, 151, 1)',
  BLUE: 'rgba(46, 140, 245, 1)',
  GREY: 'rgba(128, 128, 128, 1)',
};

export const BACKGROUND_ACTIVE = {
  PURPLE: 'rgba(146, 121, 244, 0.75)',
  GREEN: 'rgba(38, 166, 154, 0.75)',
  RED: 'rgba(239, 83, 80, 0.75)',
  ORANGE: 'rgba(245, 172, 46, 0.75)',
  WHITE: 'rgba(128, 131, 151, 0.75)',
  BLUE: 'rgba(46, 140, 245, 0.75)',
};

export const BACKGROUND = {
  PURPLE: 'rgba(146, 121, 244, 0.4)',
  GREEN: 'rgba(38, 166, 154, 0.4)',
  RED: 'rgba(239, 83, 80, 0.4)',
  ORANGE: 'rgba(245, 172, 46,0.4)',
  WHITE: 'rgba(128, 131, 151, 0.4)',
  BLUE: 'rgba(46, 140, 245, 0.4)',
  GREY: 'rgba(128, 128, 128, 0.4)',
};

export const THEME = {
  select: {
    slim: {
      field: { general: { icon_width: '30px' as Width, font_size: '12px', padding: '0px 12px' } },
      options: {
        general: { font_size: '12px', padding: '4px' },
        settings: { padding: 4, option_height: 26 },
      },
    },
  },
  input: {
    slim: {
      field: { general: { icon_width: '30px' as Width, font_size: '12px' } },
    },
  },
  button: {
    slim: {
      general: { font_size: '12px' },
    },
  },
};
